import React from 'react';
import { useParams } from 'react-router-dom';

import Table from '../../components/UserByBusinessTeam/Table';
import Page from '../../layout/DefaultManager';

export default function UserByBusinessTeamCell() {
  const { id, name } = useParams();

  return (
    <Page
      path={`/solicitation-by-business-team-cell/${id}`}
      title={`Célula ${name}`}
      // subTitle={`Usuários Cadastrados no Business Team ${name}`}
      description={`Usuários Cadastrados na Célula ${name}`}
      selectedKey="4"
      hasActionCreate={false}
      hasActionUpdate={false}
      hasActionDelete={false}
      Table={Table}
    />
  );
}
